export default function Section({
  children,
  id,
  className = "",
  background = "bg-bg-surface",
  padding = "md",
}) {
  const paddings = {
    sm: "py-sectionSm",
    md: "py-section",
    lg: "py-sectionLg",
    none: "",
  };

  return (
    <section
      id={id}
      className={`
        ${background}
        ${paddings[padding]}
        w-full
        relative
        ${className}
      `}
    >
      {children}
    </section>
  );
}